import { Typography } from '@mui/material';
import { Variant } from '@mui/material/styles/createTypography';

import { SxType, tabTextLabelSx } from '@/shared';

export type TabTextLabelProps = {
  text: string;
  pt?: string | number;
  pl?: string | number;
  mt?: string | number;
  pb?: string | number;
  variant?: Variant | 'inherit';
  uppercase?: boolean;
  color?: string;

  sx?: SxType;
};

const TabTextLabel: React.FC<TabTextLabelProps> = ({
  text,
  pt = '0px',
  pl = '24px',
  mt = '15px',
  pb = '24px',
  variant = 'h6',
  uppercase = true,
  color = '#6c737fb0',
  sx,
}) => {
  return (
    <Typography
      variant={variant}
      sx={
        sx || {
          ...tabTextLabelSx,
          pt,
          pl,
          mt,
          pb,
          color,
        }
      }
    >
      {uppercase ? text.toUpperCase() : text}
    </Typography>
  );
};

export default TabTextLabel;
